import { createAction, props } from '@ngrx/store';

export enum RolesActionTypes {
  GetSuccess = '[Roles] Get Success',
}

export const rolesLoad = createAction('[Roles] Load', props<{ payload: any }>());

export const rolesLoadSuccess = createAction('[Roles] Load Success', props<{ payload: any }>());

export const rolesGet = createAction('[Roles] Get', props<{ payload: any }>());

export const rolesGetSuccess = createAction('[Roles] Get', props<{ payload: any }>());
